"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SymfonyRouter_1 = __importDefault(require("@react/common/SymfonyRouter/SymfonyRouter"));
const Tooltip_1 = __importDefault(require("@web/common/Tooltip"));
(() => {
    const removeAllFromComparatorButton = document.querySelector('.comparator-remove-all-offers');
    if (removeAllFromComparatorButton) {
        removeAllFromComparatorButton.addEventListener('click', (event) => {
            event.preventDefault();
            const url = SymfonyRouter_1.default.getRoute('api.comparator.remove_all_offers', {});
            const xhr = new XMLHttpRequest();
            xhr.open('DELETE', url, true);
            xhr.onload = () => {
                if (xhr.status === 200) {
                    const headerComparePriceOffersLink = document.getElementById('header-compare-price-offers-link');
                    const headerCompareItemsCounter = document.getElementById('comparison-items-count');
                    const comparatorTableContainer = document.getElementsByClassName('comparator-table-container')[0];
                    const removeAllFromComparisonEvent = new Event('comparator.remove_all_from_comparison');
                    document.dispatchEvent(removeAllFromComparisonEvent);
                    if (headerComparePriceOffersLink) {
                        (() => new Tooltip_1.default(headerComparePriceOffersLink))();
                    }
                    if (headerCompareItemsCounter) {
                        headerCompareItemsCounter.innerHTML = '0';
                    }
                    if (comparatorTableContainer) {
                        comparatorTableContainer.remove();
                    }
                    document.body.classList.remove('comparator-panel-visible');
                }
            };
            xhr.send();
        });
    }
})();
